import React, { Component } from "react"
import "./PopupMobile.scss"
import _Remote from "../../api/Remote.json"
import BuyButton from "../Helpers/Buttons/BuyButton"

class PopupMobile extends Component {
    constructor(props) {
        super();
        this.togglePopup = this.togglePopup.bind(this);
        this.state = {
            isActive: false,
            current: 0
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            isActive: true,
            current: nextProps.current
        })
    }
    togglePopup() {
        this.setState({
            isActive: !this.state.isActive
        })
    }
    render() {
        const data = _Remote[this.state.current];
        return (
            <div className={`popup ${this.state.isActive ? " active" : ""}`}>
                <div className="close" onClick={this.togglePopup}>
                    <i aria-hidden="true" className="fa fa-close"></i>
                </div>
                <div className="pop-padding">
                    <div className="pop-container">
                        <div className="text" dangerouslySetInnerHTML={{ __html: data.HTML }}></div>
                        {data.purchaseLink ? <BuyButton sectionName="רכיב שלט" buttonText={"לחץ להזמנה"} onClick={() => window.open(data.purchaseLink, "_blank")} /> : ""}
                    </div>
                </div>
            </div>
        )
    }
}

export default PopupMobile;


// WEBPACK FOOTER //
// ./src/Components/Remote/PopupMobile.jsx